module.exports = __webpack_public_path__ + "static/media/send-plane-icon.d092a136.svg";